import React from 'react'
import s from './Checkout.module.scss'
import AddressCard from './AddressCard'
import CartItemRow from '../ShoppingCart/CartItemRow'
import Button from 'components/shared/Button'
import { useNavigate } from 'react-router-dom'

const singleItem = {
    "id": 54,
    "created_at": "2024-12-18T09:24:38.431642+00:00",
    "product": {
        "id": 3,
        "sku": "MAN001",
        "name": "Manicure",
        "brand": null,
        "image": "https://res.cloudinary.com/dxghjvqwv/image/upload/v1734457503/manicure_mzihzs.png",
        "price": 20,
        "salon": null,
        "stats": null,
        "stock": 10,
        "active": true,
        "amount": null,
        "meausre": null,
        "reorder": null,
        "in_stock": true,
        "old_price": null,
        "warehouse": null,
        "created_at": "2024-01-25T06:00:00+00:00",
        "category_id": 2,
        "description": "Basic manicure with polish of your choice",
        "unique_name": "manicure",
        "desc_details": null,
        "currency_name": "USD",
        "min_stock_level": 5
    },
    "order_id": 65,
    "appointment": null,
    "actions_count": 3,
    "actions_price": 60
}

const Details = ({ setOpenShoppingCartMenu }) => {
    const navigate = useNavigate()
    return (
        <div className={s.details}>
            <div className={s.details_inner}>
                <div className={s.details_time}>
                    <div className={s.details_time_title}>Estimated Delivery Time</div>
                    <div className={s.details_time_date}>14-18 Sep 2024</div>
                </div>
                <div className={s.details_shipping_to}>Guy Hawkins (316) 555-0116</div>
                <AddressCard
                    address="2118 Thornridge Cir. Syracuse, Connecticut 35624"
                    number="(316) 555-0116"
                    onEdit={() => console.log(123)}
                />
                <CartItemRow
                    item={singleItem}
                    onPlus={() => console.log(123)}
                    onMinus={() => console.log(123)}
                    handleProductFromBasket={() => console.log(123)}
                />
            </div>
            <div>
                <Button wide purple onClick={() => {
                    navigate('/feed')
                    setOpenShoppingCartMenu(false)
                }}>Leave a review</Button>
            </div>
        </div>
    )
}

export default Details